import { createStore } from 'zustand/vanilla';

// The one-item-at-a-time vs continuous-flow choice is a display preference, so it
// is remembered across sessions rather than stored in the flow snapshot.
const CONTINUOUS_MODE_KEY = 'dawid.continuousMode';

function readStoredContinuousMode() {
    try {
        return typeof localStorage !== 'undefined'
            && localStorage.getItem(CONTINUOUS_MODE_KEY) === 'true';
    } catch (err) {
        return false; // private browsing / storage disabled
    }
}

function storeContinuousMode(value) {
    try {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(CONTINUOUS_MODE_KEY, value ? 'true' : 'false');
        }
    } catch (err) {
        /* preference simply is not persisted */
    }
}

export function createUiStore() {
    const store = createStore((set) => ({
        menuFixed: false,
        showSummary: false,
        continuousMode: readStoredContinuousMode(),
        contractGenerated: false,
        contract: null,
        contractError: false,
        hasGlobalError: false,
        globalErrorInfo: '',
        emailAddress: '',

        setMenuFixed: (value) => set({ menuFixed: !!value }),
        setShowSummary: (value) => set({ showSummary: !!value }),
        setContinuousMode: (value) => {
            const next = !!value;
            storeContinuousMode(next);
            set({ continuousMode: next });
        },
        setEmailAddress: (value) => set({ emailAddress: value || '' }),

        setContract: ({ file, error }) => {
            if (file === 0) {
                set({ contractGenerated: true, contract: '', contractError: error || true });
            } else {
                set({ contractGenerated: true, contract: file, contractError: false });
            }
        },
        clearContract: () => set({ contractGenerated: false, contract: null, contractError: false }),

        setGlobalError: (err) => set({
            hasGlobalError: true,
            globalErrorInfo: `${err.message}\n${err.stack || ''}`,
        }),
        clearGlobalError: () => set({ hasGlobalError: false, globalErrorInfo: '' }),
    }));
    return { store };
}
